export default __webpack_public_path__ + "static/media/pencil.fdaa70c3.svg";